import React from "react";
import { withNavBars } from "../../HOCs";
import { EmployeesBookingCalendar } from "./employeesBooking";

class EmployeesBookingParent extends React.Component {
    render() {
        return <EmployeesBookingCalendar />
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(EmployeesBookingParent, props);